<template>
  <v-dialog v-model="openDialog" persistent max-width="800px">
    <v-card>
      <v-card-title class="mx-3 pl-6 pt-4">
        <span class="text-h5">Benutzergruppen bearbeiten</span>
      </v-card-title>
      <v-divider class="mx-9 mb-5" />
      <v-card-text class="py-0">
        <v-row>
          <v-col>
            <v-text-field
              bg-color="accent"
              variant="filled"
              hide-details
              label="ID"
              readonly
              disabled
              v-model="userCopy.userId"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text>
        <v-list>
          <v-list-item-title
            :style="{
              backgroundColor:
                $vuetify.theme.global.name === 'dark' ? '#1e1e1e' : '',
            }"
          >
            <span class="text-h6">Benutzergruppen</span></v-list-item-title
          >
          <v-list-item v-for="(group, i) in filteredUserGroups" :key="i">
            <div class="d-flex align-center">
              <v-tooltip
                v-if="
                  !isInstanceOwner &&
                  group.tenantId === null &&
                  !group.allowAssignmentToTenantUsers
                "
                location="bottom"
              >
                <template v-slot:activator="{ props }">
                  <div v-bind="props">
                    <v-checkbox
                      v-model="userCopy.groups"
                      :value="group.id"
                      hide-details
                      :disabled="true"
                    ></v-checkbox>
                  </div>
                </template>
                <span>Nur Instanzbesitzer können diese Gruppe zuweisen</span>
              </v-tooltip>
              <v-checkbox
                v-else
                v-model="userCopy.groups"
                hide-details
                density="compact"
                :value="group.id"
              ></v-checkbox>

              <v-list-item-title class="ml-4">{{
                group.name
              }}</v-list-item-title>
            </div>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn variant="outlined" @click="closeDialog">Abbrechen</v-btn>
        <v-btn
          class="mr-2"
          variant="flat"
          color="primary"
          @click="saveUserGroups"
          >Speichern</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "TenantUserEditUserGroupDialog",
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
    userGroups: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      userCopy: {},
    };
  },
  watch: {
    user: {
      handler() {
        this.userCopy = JSON.parse(JSON.stringify(this.user));
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters({
      isInstanceOwner: "user/isInstanceOwner",
      isTenantOwner: "user/isTenantOwner",
    }),
    openDialog: {
      get() {
        return this.open;
      },
    },
    filteredUserGroups() {
      return this.userGroups?.filter(
        (group) => group.tenantId !== null || group.allowAssignmentToTenantUsers
      );
    },
  },
  methods: {
    closeDialog() {
      this.$emit("close");
    },
    saveUserGroups() {
      this.$emit("save", this.userCopy.userId, this.userCopy.groups);
    },
  },
};
</script>

<style scoped></style>
